import React from 'react';
import { Box, Tooltip } from '@mui/material';

interface MetricButtonProps {
  tip: string;
  color: string;
  onClick: () => void;
  children: React.ReactNode;
}

/**
 * A figure on Org Members that opens a detail view. Dotted underline at rest so
 * it reads as clickable before it's hovered; solid on hover.
 */
const MetricButton = ({ tip, color, onClick, children }: MetricButtonProps) => (
  <Tooltip title={tip} placement="top">
    <Box
      component="button"
      type="button"
      onClick={onClick}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        p: 0,
        m: 0,
        border: 'none',
        bgcolor: 'transparent',
        cursor: 'pointer',
        fontFamily: 'Inter, sans-serif',
        fontSize: 14,
        fontWeight: 600,
        lineHeight: 1.43,
        color,
        textDecoration: 'underline dotted',
        textUnderlineOffset: '4px',
        '&:hover': { textDecorationStyle: 'solid' }
      }}
    >
      {children}
    </Box>
  </Tooltip>
);

export default MetricButton;
